const embedYoutubeUrl = url => {
  if (!url || typeof url !== 'string' || !url.includes('www.youtube.com/v/')) return url;
  const groups = url.match(/v\/([a-zA-Z0-9_-]+)&?/);
  const id = groups != null && groups.length ? groups[1] : null;
  if (!id) return url;
  return `https://www.youtube.com/embed/${id}`;
};

export default embedYoutubeUrl;